"use client";

import { Modal } from "@/components/Modal";
import { PricingContent } from "@/components/pricing/PricingContent";
import { usePricingModal } from "@/lib/zustand/usePricingModal";
import { UserNoDates } from "@/types/types";

export function PricingModal({
  user,
  numberOfModels,
}: {
  user: UserNoDates | null;
  numberOfModels: number;
}) {
  const pricingModalOpen = usePricingModal((state) => state.open);

  const pricingModalClose = usePricingModal((state) => state.setClose);

  return (
    <Modal
      open={pricingModalOpen}
      closeModal={pricingModalClose}
      title="Pricing"
      widthMode="ultraWide"
    >
      <PricingContent
        user={user}
        numberOfModels={numberOfModels}
        closeModal={pricingModalClose}
      />
    </Modal>
  );
}
